import React, { useEffect, useState, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { heroSlides } from "../mock";

export default function HeroCarousel() {
  const [i, setI] = useState(0);
  const total = heroSlides.length;

  const next = useCallback(() => setI((p) => (p + 1) % total), [total]);
  const prev = () => setI((p) => (p - 1 + total) % total);

  useEffect(() => {
    const id = setInterval(next, 6000);
    return () => clearInterval(id);
  }, [next]);

  return (
    <section className="relative w-full overflow-hidden bg-[#F5EFE6]">
      <div className="relative w-full h-[78vh] min-h-[520px] max-h-[820px] md:h-[68vh] md:min-h-[440px] md:max-h-[720px]">
        {heroSlides.map((s, idx) => (
          <a
            key={s.id}
            href={s.href}
            target="_blank"
            rel="noreferrer"
            aria-label={s.title}
            className={`absolute inset-0 block transition-opacity duration-[1200ms] ease-in-out ${
              idx === i ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img
              src={s.img}
              alt={s.title}
              className="w-full h-full object-cover"
              loading={idx === 0 ? "eager" : "lazy"}
            />
          </a>
        ))}

        <button
          onClick={prev}
          aria-label="Previous"
          className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full bg-white/70 hover:bg-white text-[#1a1a1a] flex items-center justify-center transition-colors"
        >
          <ChevronLeft size={20} />
        </button>
        <button
          onClick={next}
          aria-label="Next"
          className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full bg-white/70 hover:bg-white text-[#1a1a1a] flex items-center justify-center transition-colors"
        >
          <ChevronRight size={20} />
        </button>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {heroSlides.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              aria-label={`Slide ${idx + 1}`}
              className={`h-[3px] transition-all duration-300 ${
                idx === i ? "w-10 bg-white" : "w-6 bg-white/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
